<template>
    <nuxt-link :to="{ name: 'contributor-profile', params: {slug: contributor.slug} }">
        <div class="contributor-banner">
            <div class="banner-bg" :style="{'--bannerUrl': `url(${contributor.profile_banner_url})`}"/>
            <div class="contributor-profile">
                <img :src="contributor.profile_image_url"/>
            </div>
            <div class="contributor-details">
                <div>
                    <span class="name">{{ contributor.name }}</span>
                    <span class="separator"> - </span>
                    <span class="location">{{ contributor.location }}</span>
                </div>
                <div class="counts">
                    <span>{{ contributor.albums_count }} Albums</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>{{ contributor.images_count }} Images</span>
                </div>
            </div>
        </div>
    </nuxt-link>
</template>

<script>
export default {
    name: 'ContributorBanner',
    props: {
        contributor: null
    }
}
</script>
